import { cpf } from 'cpf-cnpj-validator';

export const validateCpf = (value: string) => cpf.isValid(value);
